var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragdropBullet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99967 3.00008C1.63148 3.00008 1.33301 2.7016 1.33301 2.33341C1.33301 1.96522 1.63148 1.66675 1.99967 1.66675C2.36786 1.66675 2.66634 1.96522 2.66634 2.33341C2.66634 2.7016 2.36786 3.00008 1.99967 3.00008Z",
    stroke: "#8098F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99967 7.66675C1.63148 7.66675 1.33301 7.36827 1.33301 7.00008C1.33301 6.63189 1.63148 6.33341 1.99967 6.33341C2.36786 6.33341 2.66634 6.63189 2.66634 7.00008C2.66634 7.36827 2.36786 7.66675 1.99967 7.66675Z",
    stroke: "#8098F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99967 12.3334C1.63148 12.3334 1.33301 12.0349 1.33301 11.6667C1.33301 11.2986 1.63148 11.0001 1.99967 11.0001C2.36786 11.0001 2.66634 11.2986 2.66634 11.6667C2.66634 12.0349 2.36786 12.3334 1.99967 12.3334Z",
    stroke: "#8098F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 3.00008C7.63148 3.00008 7.33301 2.7016 7.33301 2.33341C7.33301 1.96522 7.63148 1.66675 7.99967 1.66675C8.36786 1.66675 8.66634 1.96522 8.66634 2.33341C8.66634 2.7016 8.36786 3.00008 7.99967 3.00008Z",
    stroke: "#8098F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 7.66675C7.63148 7.66675 7.33301 7.36827 7.33301 7.00008C7.33301 6.63189 7.63148 6.33341 7.99967 6.33341C8.36786 6.33341 8.66634 6.63189 8.66634 7.00008C8.66634 7.36827 8.36786 7.66675 7.99967 7.66675Z",
    stroke: "#8098F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 12.3334C7.63148 12.3334 7.33301 12.0349 7.33301 11.6667C7.33301 11.2986 7.63148 11.0001 7.99967 11.0001C8.36786 11.0001 8.66634 11.2986 8.66634 11.6667C8.66634 12.0349 8.36786 12.3334 7.99967 12.3334Z",
    stroke: "#8098F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragdropBullet);
export default __webpack_public_path__ + "static/media/dragdrop-bullet.9378167b2188284a4bd440273e8aaa00.svg";
export { ForwardRef as ReactComponent };